var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-field',{attrs:{"attribute":_vm.attribute,"type":"radio","label":_vm.label,"required":_vm.required,"errorKeys":_vm.errorKeys}},[_c('div',{staticClass:"radio-options"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }